import React, { FC } from 'react'
import styled from 'styled-components'

import * as PT from 'modules/Pricing/types'

import Spacer from 'components/Spacer'

import * as T from 'types'
import * as E from 'types/enums'

import PackageCard from './PackageCard'
import PackageDisclaimer from './PackageDisclaimer'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const PackageCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

interface IProps {
  pricingPackagesObj: PT.IPricingPackageObject
  featuresExclusive: PT.IFeatures
  packageInCart: E.PackageType
  onClickSelect: (type: E.PackageType) => void
  purchasedPackage: E.PackageType | undefined
  listingPricingPackage: T.IOrderUnpopulated | undefined
  selectable?: boolean
  initialized?: boolean
}

const PackageCards: FC<IProps> = ({
  pricingPackagesObj,
  featuresExclusive,
  packageInCart,
  onClickSelect,
  purchasedPackage,
  listingPricingPackage,
  selectable,
  initialized,
}) => (
  <Container>
    <PackageCardsContainer>
      <PackageCard
        subtitle="Best for home sellers with basic needs."
        pricingPackage={pricingPackagesObj.Basic}
        featuresIncluded={featuresExclusive.Basic}
        packageType={E.PackageType.basic}
        selectable={selectable}
        selectedPackage={selectable ? (packageInCart as E.PackageType) : null}
        onClickSelect={onClickSelect}
        purchased={listingPricingPackage && purchasedPackage === E.PackageType.basic}
        purchasedPackage={purchasedPackage}
        disabled={selectable && (!initialized || !!purchasedPackage)}
        initialized={initialized}
      />
      <PackageCard
        subtitle="Best for home sellers looking for professional help."
        pricingPackage={pricingPackagesObj.Premium}
        featuresIncluded={featuresExclusive.Premium}
        packageType={E.PackageType.premium}
        selectable={selectable}
        selectedPackage={selectable ? (packageInCart as E.PackageType) : null}
        onClickSelect={onClickSelect}
        purchased={listingPricingPackage && purchasedPackage === E.PackageType.premium}
        purchasedPackage={purchasedPackage}
        disabled={selectable && (!initialized || !!purchasedPackage)}
        initialized={initialized}
      />
      <PackageCard
        mode={E.PackageCardMode.Best}
        subtitle="Best for home sellers looking for end-to-end support."
        pricingPackage={pricingPackagesObj.Platinum}
        featuresIncluded={featuresExclusive.Platinum}
        packageType={E.PackageType.platinum}
        selectable={selectable}
        selectedPackage={selectable ? (packageInCart as E.PackageType) : null}
        onClickSelect={onClickSelect}
        purchased={listingPricingPackage && purchasedPackage === E.PackageType.platinum}
        purchasedPackage={purchasedPackage}
        disabled={selectable && (!initialized || !!purchasedPackage)}
        initialized={initialized}
      />
      <PackageCard
        mode={E.PackageCardMode.ComingSoon}
        subtitle="Best for home sellers who want a full agent experience."
        pricingPackage={pricingPackagesObj.Elite}
        featuresIncluded={featuresExclusive.Elite}
        packageType={E.PackageType.elite}
        selectable={selectable}
        selectedPackage={selectable ? (packageInCart as E.PackageType) : null}
        onClickSelect={onClickSelect}
        purchased={listingPricingPackage && purchasedPackage === E.PackageType.elite}
        purchasedPackage={purchasedPackage}
        disabled={selectable && (!initialized || !!purchasedPackage)}
        initialized={initialized}
      />
    </PackageCardsContainer>
    <Spacer size={20} />
    <PackageDisclaimer featuresExclusive={featuresExclusive} />
  </Container>
)

export default PackageCards
